import { useState, useEffect } from "react";
import { isInteractiveQuiz } from "../../utils/pollTypes.js";
import { removePollItem, updateQuizFlags } from "../../hooks/adminStore.js";
import { updatePresentationState } from "../../hooks/usePresentationSync.js";

export default function useInteractiveQuizControls(session) {
  const [interactiveQuizzes, setInteractiveQuizzes] = useState([]);

  useEffect(() => {
    if (!session) return;
    const list = Array.isArray(session.polls) ? session.polls.filter(isInteractiveQuiz) : [];
    setInteractiveQuizzes(list);
  }, [session]);

  const safeList = Array.isArray(interactiveQuizzes) ? interactiveQuizzes : [];
  const activeInteractiveQuizzes = safeList.filter((k) => k.isApproved === true);

  function interactiveQuizToggle(id, isApproved) {
    const updated = interactiveQuizzes.map((k) => {
      return String(k.id) === String(id) ? { ...k, isApproved, showresult: false, intropage: isApproved } : k;
    });
    setInteractiveQuizzes(updated);
    if (!session) return;
    if (isApproved) {
      // Activating opens the quiz on its intro page (isApproved: true, showresult: false,
      // intropage: true, no question live) - the same state Start publishes for slide 0.
      const quiz = updated.find((k) => String(k.id) === String(id));
      if (quiz) updatePresentationState(session.sessionId, quiz, 0);
    } else {
      removePollItem(session.sessionId, id);
      const activeCount = updated.filter((k) => k.isApproved).length;
      if (activeCount === 0) interactiveQuizEnabled(false);
    }
  }

  function interactiveQuizEnabled(enabled) {
    if (session) updateQuizFlags(session.sessionId, { interactiveQuizEnabled: enabled });
  }

  function turnOffAllQuizzes() {
    const updated = interactiveQuizzes.map((k) => ({ ...k, isApproved: false, showresult: false }));
    setInteractiveQuizzes(updated);
    if (!session) return;
    activeInteractiveQuizzes.forEach((k) => removePollItem(session.sessionId, String(k.id)));
    interactiveQuizEnabled(false);
  }

  return { interactiveQuizzes, activeInteractiveQuizzes, interactiveQuizToggle, interactiveQuizEnabled, turnOffAllQuizzes };
}
